import db from "../db/database";

export const findBuchtById = async (value: number) => {
  if (value) {
    const bucht = await db.getBuchtById(value);
    return bucht[0];
  }
  return;
};
